import React from 'react'

import { Skeleton } from '@root/shared/ui-kit'

import { AnalysisCommon } from './analysis-common'

type Props = {
  rows: number
}

export const AnalysisSkeleton = (props: Props) => {
  const rows = Array.from({ length: props.rows }, () => ({
    point: <Skeleton.Line width={Skeleton.between(50, 120) + 'px'} />,
    value: <Skeleton.Line width={Skeleton.between(30, 50) + 'px'} />,
  }))

  return (
    <AnalysisCommon value={undefined}>
      <AnalysisCommon.Main>
        {rows.map((row, index) => (
          <React.Fragment key={index}>
            <AnalysisCommon.Point>{row.point}</AnalysisCommon.Point>
            <AnalysisCommon.Value>{row.value}</AnalysisCommon.Value>
          </React.Fragment>
        ))}
      </AnalysisCommon.Main>
    </AnalysisCommon>
  )
}
